(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-row"] && !Shopify.designMode) return;
  try {
    // Adds to the cart in the background, so a shopper working down a list of
  // literature doesn't lose their place between items.
  //
  // Every form here is an ordinary POST to /cart/add that works on its own, and
  // this only intercepts the submit — with JavaScript off the page still adds,
  // it just reloads the way it always did.
  //
  // One delegated listener covers every row on the page, including rows the
  // theme editor re-renders, so there's nothing to re-initialise.
  (() => {
    // Confirmations go to the shared toast stack (see `snippets/toast.liquid`)
    // rather than into the row. A row is a few lines tall and a list of them
    // fills the screen, so a message printed in place is as likely to be below
    // the fold as not — and adding from the last visible row scrolls nothing
    // into view. The toast is always in the same corner.
    //
    // Both messages name the product, which is the thing the row itself used to
    // supply by sitting next to it.
    function notify(message, isError) {
      if (!message) return;

      if (typeof window.showToast === 'function') {
        window.showToast(message, { variant: isError ? 'error' : 'success' });
      }
    }

    // The header renders a count for the mobile row and another for desktop, so
    // this deliberately updates all of them.
    function setCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = count;
      });
    }

    // /cart/add.js replies with the line item it added, not with a cart total,
    // so the new count has to be read back separately.
    async function refreshCartCount(cartUrl) {
      if (!cartUrl) return;

      const response = await fetch(`${cartUrl}.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return;

      const cart = await response.json();
      setCartCount(cart.item_count);
    }

    async function addToCart(form) {
      if (form.dataset.busy) return;

      const button = form.querySelector('[data-quantity-submit]');
      const quantityField = form.elements.namedItem('quantity');
      const variantField = form.elements.namedItem('id');
      if (!quantityField || !variantField) return;

      // `min="1"` already stops the spinner going below one, but the field can
      // still be cleared or typed into, so the floor is applied again here.
      const quantity = Math.max(1, Math.floor(Number(quantityField.value) || 1));
      quantityField.value = quantity;

      form.dataset.busy = 'true';
      if (button) button.disabled = true;

      try {
        const response = await fetch(`${form.getAttribute('action')}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: variantField.value, quantity }],
          }),
        });

        const result = await response.json();

        if (!response.ok) {
          // Shopify explains the refusal in `description` — most often that the
          // quantity asked for is more than the stock left.
          notify(result.description || result.message || form.dataset.errorMessage, true);
          return;
        }

        await refreshCartCount(form.dataset.cartUrl);

        // Back to one: leaving a large quantity in the field turns an
        // accidental second click into an order nobody meant to place.
        quantityField.value = 1;

        notify(form.dataset.addedMessage, false);
      } catch (error) {
        notify(form.dataset.errorMessage, true);
      } finally {
        delete form.dataset.busy;
        if (button) button.disabled = false;
      }
    }

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form.matches || !form.matches('[data-quantity-form]')) return;

      event.preventDefault();
      addToCart(form);
    });

    // A link inside the summary is the one thing there that doesn't mean "show
    // me the variants". Caught on the way down, so the click never reaches the
    // summary and the row doesn't toggle as well — following the link is a
    // default action, which stopping propagation leaves alone.
    document.addEventListener(
      'click',
      (event) => {
        if (!event.target.closest) return;
        if (event.target.closest('.product-row__summary a')) event.stopPropagation();
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-field"] && !Shopify.designMode) return;
  try {
    // Drives the − and + either side of the input. One delegated listener covers
  // every field on the page, including rows the theme editor re-renders, so
  // there's nothing to re-initialise.
  //
  // Scoped to `.quantity-field` so it leaves the product page's and the cart's
  // own steppers, which have their own handlers, alone.
  (() => {
    document.addEventListener('click', (event) => {
      if (!event.target.closest) return;

      const step = event.target.closest('[data-quantity-field-step]');
      if (!step) return;

      const field = step.closest('.quantity-field')?.querySelector('.quantity-field__input');
      if (!field) return;

      // The field can be cleared or typed into, so the floor is applied to
      // whatever is actually in it rather than to the last stepped value.
      const min = Number(field.min) || 1;
      const current = Math.floor(Number(field.value) || min);

      field.value = Math.max(min, current + Number(step.dataset.quantityFieldStep));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast"] && !Shopify.designMode) return;
  try {
    // Fills the stack rendered above. Everything that calls this treats it as
  // optional — the theme works without a confirmation, so a missing container
  // is a silent no-op rather than an exception on the way to the cart.
  (() => {
    const VISIBLE_MS = 5000;
    const ENTER_MS = 320;
    const EXIT_MS = 320;
    const MAX_VISIBLE = 4;

    // A toast's pending dismissal, kept off the element itself so nothing in
    // the DOM has to carry script state.
    const timers = new WeakMap();

    function announce(message, variant) {
      const politeness = variant === 'error' ? 'assertive' : 'polite';
      const region = document.querySelector(`[data-toast-announcer="${politeness}"]`);
      if (!region) return;

      // Writing the same text into a live region twice running is a no-op, and
      // adding two of the same thing to a cart is exactly when that happens.
      // Clearing first, a frame apart, makes the second one land.
      region.textContent = '';
      window.setTimeout(() => {
        region.textContent = message;
      }, 60);
    }

    function dismiss(item) {
      if (!item || item.hasAttribute('data-leaving')) return;
      item.setAttribute('data-leaving', '');
      window.clearTimeout(timers.get(item));

      // Pin the height it currently has before animating it to nothing, so the
      // toasts above close the gap as this one drops.
      item.style.height = `${item.offsetHeight}px`;
      void item.offsetHeight;

      item.removeAttribute('data-visible');
      item.style.height = '0px';

      window.setTimeout(() => item.remove(), EXIT_MS + 60);
    }

    // Restartable, because the timer is paused whenever a shopper is plainly
    // still reading: five seconds is short, and a pointer resting on a toast or
    // focus inside it says the message hasn't been taken in yet.
    function scheduleDismissal(item, remaining) {
      let left = remaining;
      let startedAt = Date.now();

      const start = () => {
        startedAt = Date.now();
        timers.set(item, window.setTimeout(() => dismiss(item), left));
      };

      const pause = () => {
        window.clearTimeout(timers.get(item));
        left = Math.max(left - (Date.now() - startedAt), 800);
      };

      item.addEventListener('pointerenter', pause);
      item.addEventListener('pointerleave', start);
      item.addEventListener('focusin', pause);
      item.addEventListener('focusout', start);

      start();
    }

    function show(message, options = {}) {
      const stack = document.querySelector('[data-toast-stack]');
      const template = document.querySelector('[data-toast-template]');
      if (!stack || !template || !message) return null;

      const item = template.content.firstElementChild.cloneNode(true);
      const variant = options.variant === 'error' ? 'error' : 'success';

      item.querySelector('.toast__message').textContent = message;
      if (variant === 'error') item.querySelector('.toast').classList.add('toast--error');

      // Appended last, so the newest sits closest to the corner the eye is
      // already in after clicking something down there.
      stack.appendChild(item);

      // Measure at its natural height, then collapse and grow back into it.
      const target = item.offsetHeight;
      item.style.height = '0px';
      void item.offsetHeight;
      item.style.height = `${target}px`;
      item.setAttribute('data-visible', '');

      // Back to `auto` once it has arrived, so a toast whose text reflows —
      // a narrow window rotated, say — isn't stuck at the height it was born at.
      window.setTimeout(() => {
        if (!item.hasAttribute('data-leaving')) item.style.height = 'auto';
      }, ENTER_MS + 60);

      announce(message, variant);

      const duration = Number.isFinite(options.duration) ? options.duration : VISIBLE_MS;
      scheduleDismissal(item, duration);

      // Oldest first: the one that has had the longest to be read is the one
      // that can be spared.
      //
      // Counted over the toasts that aren't already on their way out.
      // `dismiss` starts an animation and leaves the node in place until it
      // finishes, so counting every child would never see the number come
      // down — and a loop waiting for it would never end.
      const live = Array.from(stack.children).filter((child) => !child.hasAttribute('data-leaving'));
      live.slice(0, Math.max(0, live.length - MAX_VISIBLE)).forEach(dismiss);

      return item;
    }

    // One delegated listener rather than one per toast, so nothing has to be
    // unbound when a toast is removed.
    document.addEventListener('click', (event) => {
      const close = event.target.closest && event.target.closest('[data-toast-close]');
      if (close) dismiss(close.closest('.toast-stack__item'));
    });

    window.showToast = show;
  })();
  } catch(e) { console.error(e); }
})();

})();
